import '../constants/authorizedUsers.js';
import '../constants/bidStatus.js';
import '../constants/bulkLoadCardStatus.js';
import { REF_VIEWPORT_HEIGHT, REF_VIEWPORT_WIDTH } from '../constants/misc.js';
import '../constants/event-names.js';
import '../constants/eventsMapObj.js';
import '../constants/Faq.js';
import '../constants/languages.js';
import '../constants/loadStatus.js';
import '../constants/lorryStatus.js';
import '../constants/lorryTypes.js';
import '../constants/mostSearchedLinks.js';
import '../constants/Pages.js';
import 'bowser';
import '../_virtual/_tslib.js';
import '../components/toast/toast.js';
import '../_services/auth.service.js';
import './getAuthIdParam.js';
import 'react';
import 'react-cookie';
import './formatDate.js';
import '../constants/StateList.js';
import './getTransporterFigure.js';
import './getDownloadsFigure.js';
import 'lodash.isequal';
import './getPageLoadSourceUTMParam.js';
import 'crypto-js';
import '../constants/serviceTypeId.js';
import '../constants/bidUpdateType.js';
import '../constants/userAction.js';
import '../constants/api.js';
import '../constants/link.js';
import '../constants/market.js';
import '../constants/payment.js';
import '../constants/admin/screenId.js';
import '../_services/const.js';

function getHeightByViewPort(valueInPx) {
    return `${(valueInPx / REF_VIEWPORT_HEIGHT) * (Math.max(window.screen.availHeight, 640) - 110)}px`;
}
function getWidthByViewPort(valueInPx) {
    return `${(valueInPx / REF_VIEWPORT_WIDTH) * window.screen.availWidth}px`;
}

export { getHeightByViewPort, getWidthByViewPort };
//# sourceMappingURL=getSizeByViewPort.js.map
